import { FileText } from 'lucide-react';
import { CuentaProfesional } from '../../../../objetos/objeto_configuracion';
import React, { useState, useEffect } from 'react';
import { formatearFechaCompleta } from '../../../../utils/utils';
import EditableField from '../../../../components/EditableFields';

const RenderCuentasSection = ({ 
  configuracion,
  onAgregarCuenta = () => {}, 
  onEliminarCuenta = () => {},
  onEditarCuenta = () => {} 
 }) => {

  console.log("abriendo configuracion",configuracion);
  
  // Estado para el formulario
  const [formData, setFormData] = useState({
    correo: '',
    linkCuenta: '',
    contrasena: '',
    nombreCuenta: '',
  });

  // Estado para la lista de cuentas.
  // Se inicializa con los datos de las props.
  const [listaCuentas, setListaCuentas] = useState(
    configuracion?.cuentaProfesional || []
  );

  useEffect(() => {
    setListaCuentas(configuracion?.cuentaProfesional || []);
  }, [configuracion?.cuentaProfesional]); 

  // Efecto para sincronizar si la prop 'configuracion' cambia desde fuera
  useEffect(() => {
    setListaCuentas(configuracion?.cuentasprofesional || []);
  }, [configuracion]);


  // Manejador para actualizar el estado del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  // Manejador para el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault(); 
    const nuevaCuenta = new CuentaProfesional(formData);

    onAgregarCuenta(nuevaCuenta);
    
    setFormData({
      correo: '',
      linkCuenta: '',
      contrasena: ''
    });
  };

  // Función para eliminar una cuenta (Ejemplo)
  const handleEliminarCuenta = (cuenta) => {
    console.log('Eliminar cuenta con ID:', cuenta.id);

    onEliminarCuenta(cuenta);
    
  };

  const updateCuentaProfesional = (field,value,cuenta) =>{

    onEditarCuenta(field,value,cuenta);

  }

  return ( 
    <div className="space-y-6">
      {/* Turnitin */}
      <div className="bg-white p-6 rounded-lg border">
        
        {/* --- Título --- */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold flex items-center">
            <FileText className="mr-2 h-5 w-5" />
            Cuentas Profesionales (Turnitin, etc.)
          </h3>
        </div>

        {/* --- Formulario --- */}
        <form onSubmit={handleSubmit} className="space-y-4 border-b border-gray-200 pb-6 mb-6">
          <h4 className="text-md font-semibold text-gray-800">Agregar Nueva Cuenta</h4>
          
          {/* --- Link de la cuenta --- */}
          <div>
            <label htmlFor="linkCuenta-prof" className="block text-sm font-medium text-gray-700 mb-1">
              Nombre de cuenta
            </label>
            <input
              type="text"
              name="nombreCuenta"
              id="nombreCuenta-prof"
              value={formData.nombreCuenta}
              onChange={handleChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Nombre de cuenta"
            />
          </div>

          {/* --- Link de la cuenta --- */}
          <div>
            <label htmlFor="linkCuenta-prof" className="block text-sm font-medium text-gray-700 mb-1">
              Link de la Cuenta (Opcional)
            </label>
            <input
              type="text"
              name="linkCuenta"
              id="linkCuenta-prof"
              value={formData.linkCuenta}
              onChange={handleChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="https://turnitin.com/login"
            />
          </div>

          {/* --- Correo --- */}
          <div>
            <label htmlFor="correo-prof" className="block text-sm font-medium text-gray-700 mb-1">
              Correo Electrónico
            </label>
            <input
              type="text"
              name="correo"
              id="correo-prof"
              value={formData.correo}
              onChange={handleChange}
              required
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="ejemplo@dominio.com"
            />
          </div>
          
          {/* --- Contraseña de la cuenta --- */}
          <div>
            <label htmlFor="contrasena-prof" className="block text-sm font-medium text-gray-700 mb-1">
              Contraseña
            </label>
            <input
              type="text"
              name="contrasena"
              id="contrasena-prof"
              value={formData.contrasena}
              onChange={handleChange}
              required
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="••••••••"
            />
          </div>
          
          <div>
            <button
              type="submit"
              className="w-full sm:w-auto flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Agregar Cuenta
            </button>
          </div>
        </form>

        {/* --- Lista de Cuentas Existentes --- */}
        <h4 className="text-md font-semibold text-gray-800 mb-4">Cuentas Existentes</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          {/* Aquí mapeamos la lista del estado */}
          {configuracion?.cuentaProfesional.length > 0 ? (
            configuracion?.cuentaProfesional.map((cuenta) => (
              <div key={cuenta.id} className="p-4 border rounded-md bg-gray-50 relative">
                <EditableField
                  field="cuentaProfesional.nombreCuenta"
                  label="Nombre Cuenta"
                  value={cuenta.nombreCuenta}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => 
                      updateCuentaProfesional(field, value, cuenta)
                  }
                />
                <EditableField
                  field="cuentaProfesional.correo"
                  label="Correo"
                  value={cuenta.correo}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => 
                      updateCuentaProfesional(field, value, cuenta)
                  }
                />
                <EditableField
                  field="cuentaProfesional.contrasena"
                  label="Contraseña"
                  value={cuenta.contrasena}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => 
                      updateCuentaProfesional(field, value, cuenta)
                  }
                />
                
                <EditableField
                  field="cuentaProfesional.linkCuenta"
                  label="Link Cuenta"
                  value={cuenta.linkCuenta}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => 
                      updateCuentaProfesional(field, value, cuenta)
                  }
                />

                <p className="text-sm text-gray-600">Fecha: {formatearFechaCompleta(cuenta.fechaActualizacionCuenta)}</p>

                {/* Botón de ejemplo para eliminar */}
                <button
                  onClick={() => handleEliminarCuenta(cuenta)}
                  className="absolute top-2 right-2 text-red-400 hover:text-red-600"
                  aria-label="Eliminar cuenta"
                >
                  {/* Icono de 'X' o basura */}
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ))
          ) : (
            <p className="text-gray-500 col-span-full">No hay cuentas para mostrar.</p>
          )}
         
        </div>
        
      </div>
      
    </div>
  );
  
};

export default RenderCuentasSection;